import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import has from "lodash/has";
import get from "lodash/get";

export default {
  getChart(ref, url, series, useRightAxis, useLegend, headers) {
    const chart = this.createChart(ref);
    this.setupChartDataSource(chart, url, headers);

    this.getDateAxis(chart);
    const valueAxis = this.getValueAxis(chart);

    let rightAxis = null;

    if (useRightAxis) {
      rightAxis = this.getRightAxis(chart);
    }

    if (useLegend) {
      this.addLegend(chart);
    }

    const scrollbar = this.getScrollBar(chart);

    const setupSeries = this.setupSeries;
    series.forEach(function(value) {
      setupSeries(value, chart, scrollbar, valueAxis, rightAxis);
    });

    this.setupScrollAxis(chart);

    return chart;
  },

  createChart(ref) {
    const chart = am4core.create(ref, am4charts.XYChart);
    chart.paddingRight = 20;
    chart.cursor = new am4charts.XYCursor();
    return chart;
  },

  setupChartDataSource(chart, url, headers) {
    if (!headers) {
      headers = [];
    }

    chart.dataSource.url = url;
    chart.dataSource.parser = new am4core.JSONParser();
    chart.dataSource.requestOptions.requestHeaders = [
      {
        key: "Accept",
        value: "application/json"
      },
      ...headers
    ];
  },

  getDateAxis(chart) {
    const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.location = 0;

    return dateAxis;
  },

  getValueAxis(chart) {
    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.tooltip.disabled = true;
    valueAxis.renderer.minWidth = 35;

    return valueAxis;
  },

  getRightAxis(chart) {
    let rightAxis = null;

    rightAxis = chart.yAxes.push(new am4charts.ValueAxis());
    rightAxis.tooltip.disabled = true;
    rightAxis.renderer.minWidth = 35;
    rightAxis.align = "right";
    rightAxis.renderer.opposite = true;

    return rightAxis;
  },

  setupSeries(data, chart, scrollbar, valueAxis, rightAxis) {
    const series = chart.series.push(new am4charts.LineSeries());
    const bullet = series.bullets.push(new am4charts.Bullet());
    const circle = bullet.createChild(am4core.Circle);
    circle.width = 4;
    circle.height = 4;
    circle.stroke = am4core.color("#fff");
    circle.strokeWidth = 1;

    series.dataFields.dateX = data.xKey;
    series.dataFields.valueY = data.yKey;

    if (has(data, "name")) {
      series.name = get(data, "name");
    }

    if (has(data, "color")) {
      const color = get(data, "color");
      series.tooltip.getFillFromObject = false;
      series.tooltip.background.fill = am4core.color(color);
      series.stroke = am4core.color(color);
      circle.fill = am4core.color(color);
    }

    if (!get(data, "rightAxis", null) || !rightAxis) {
      series.yAxis = valueAxis;
    } else {
      series.yAxis = rightAxis;
    }

    series.tooltipText = "{valueY.value}";
    scrollbar.series.push(series);
  },

  getScrollBar(chart) {
    const scrollbar = new am4charts.XYChartScrollbar();
    chart.scrollbarX = scrollbar;
    chart.scrollbarX.parent = chart.bottomAxesContainer;
    chart.scrollbarX.minHeight = 40;

    return scrollbar;
  },

  setupScrollAxis(chart) {
    const scrollAxis = chart.scrollbarX.scrollbarChart.xAxes.getIndex(0);
    scrollAxis.renderer.labels.template.disabled = true;
    scrollAxis.renderer.grid.template.disabled = true;
  },

  addLegend(chart) {
    chart.legend = new am4charts.Legend();
    chart.legend.position = "top";
    chart.legend.width = 600;
    chart.legend.paddingBottom = 50;
    chart.legend.fontSize = 12;
    chart.legend.paddingLeft = 150;
  }
};
